// extracted by mini-css-extract-plugin
module.exports = {"pageMargin":"style__pageMargin__ggqai"};